/**
 * Enumerates all possible types of shipping methods.
 *
 * These are not the shipping methods themselves but the type that categorizes
 * the shipping method. This string value comes from an external source (eg.
 * SFCC), is sorted on on the application and then this value is sent to the
 * order management system.
 *
 *
 * Additional values will need to be added to the enum as we onboard more brands
 * and locales although the values themselves will remain mostly unchanged.
 */
enum ShippingMethod {
  /**
   * **Standard Ground Shipping**.
   *
   * Delivery time: 3-6 business days.
   *
   * Does not apply for carts in which all items are discounted.
   * In those cases, {@link ShippingMethod.STG2 STG2} applies instead.
   */
  STG = 'STG',

  /**
   * **Standard Ground Shipping (Special Case)**.
   *
   * Delivery time: 3-6 business days.
   *
   * Functionally equal to STG, but applies only for carts in which all items
   * are discounted. In any other case, {@link ShippingMethod.STG STG} applies instead.
   *
   * Meant for accounting purposes.
   */
  STG2 = 'STG2',

  /**
   * **Expedited Shipping**.
   *
   * Delivery time: 2-3 business days.
   *
   * Available for all carts, except when the `shipToAddress` is a PO Box or
   * outside the country.
   */
  ST2 = 'ST2',

  /**
   * **Fastest Shipping**.
   *
   * Delivery time: 1-2 business days.
   *
   * Available for all carts, except when the `shipToAddress` is a PO Box or
   * outside the country.
   */
  STO = 'STO',

  /**
   * **USPS Ground**.
   *
   * Delivery time is not disclosed.
   *
   * The only method available when the `shipToAddress` is a PO Box.
   */
  USPSGround = '000001_USPS_P_GND',

  /**
   * **SFS International**.
   *
   * Delivery time is not disclosed.
   *
   * The only method available when the `shipToAddress` is outside of the
   * country.
   */
  SFSIntl = '000001_USPS_P_INTL'
}

export default ShippingMethod;
